
<v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    persistent
    no-click-animation
    transition="dialog-bottom-transition"
>
    <div class="white" style="margin-top: 8px;height: calc(100% - 15px); padding-right: 45px;">
        <div
            class="v-flex primary white"
            style="border-radius: 4px; margin-left: 75px"
        >
            <c-site-title :site="site" class="pl-2" style="padding-top: 2px" />
            <v-spacer />
            <v-btn
                text
                @click="onClose"
                class="pl-0 pr-0"
            >
                <v-icon size="22" color="white">mdi-close</v-icon>
            </v-btn>
        </div>
        <div class="w-100 mt-5">
            <t-site
                :key       = "refresh"
                ref        = "tabs"
                :site      = "site"
                :tab-index = tabIndex
                @close     = "onClose"
                @refresh   = "onRefresh"
                @saved     = "onSaved"
                @type      = "onType"
                @customer  = "onCustomer"
            />
        </div>
    </div>
</v-dialog>
